import { UserLicense, UserLicenseAssign } from "@medapro-types/UserManager/UserManager";
import api from "./api";
import endpoints from "./endpoints";

export default {
  get: async function (): Promise<UserLicense[]> {
    const response = await api.get(endpoints.userLicenses.get);
    return response.data;
  },
  assign: async function (userLicenses: UserLicenseAssign[]): Promise<Record<string, Record<number, string>>> {
    const response = await api.post(endpoints.userLicenses.assign, userLicenses);
    return response.data;
  },
  unassign: async function (userLogonIds: string[]): Promise<string> {
    const response = await api.post(endpoints.userLicenses.unassign, userLogonIds);
    return response.data;
  }
};
